import { render, staticRenderFns } from "./FormHintText.vue?vue&type=template&id=21b8e498&"
import script from "./FormHintText.vue?vue&type=script&lang=ts&"
export * from "./FormHintText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports